import Page from '../page/Page'

function App() {
    const path = '/'
    return <Page path={path}/>
}

export default App;